import {ACTION_TYPES} from 'Utils/constants';
import setJourneyStop from './setJourneyStop';

const setJourneyStage = stage => (dispatch, getState) => {
    if (!stage) {
        setJourneyStop({reset: true})(dispatch, getState);
    }

    dispatch({
        type: ACTION_TYPES.SET_JOURNEY_STAGE,
        data: stage,
    });
};

export default setJourneyStage;
